export default '0.14.5';



// WEBPACK FOOTER //
// ./version.js